export const navigationPaths = {
  workerDetail: `/admin/workers/view/:id`,
  shiftDetail: `/admin/jobs/view/:jobId#S:shiftId`,
} as const;
